import Image from "next/image";
import { ReactNode } from "react";
import React from "react";

type Props = {
  children?: ReactNode;
};

/**
 * 非会員用 ロゴありメニューなしレイアウト
 * @constructor
 */
const NonMemberLayout = ({ children }: Props) => {
  return (
    <div className="min-h-screen bg-theme-thin">
      <header>
        <div className="flex justify-center items-center pt-3 pb-1.5 bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.25)] md:pt-2 md:pb-1">
          <div className="w-[112px] h-auto md:w-auto">
            <Image
              src="/customer/logo.svg"
              width="178"
              height="34"
              className="block"
              alt="Yoyacoo"
            ></Image>
          </div>
        </div>
      </header>
      <div className="flex flex-col items-center">
        <main className="grow mt-14 mb-20 w-full max-w-[760px]">
          {children}
        </main>
      </div>
    </div>
  );
};

export default NonMemberLayout;
